import { GravityReservationPopup } from '@scripts/reserve-thematic/classes/gravity-reservation-popup.js';

document.addEventListener('DOMContentLoaded', () => {
    new GravityReservationPopup();
});
